import React, { useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '../../../../../components/DemoContainer/DemoContainer';
import dayjs from "dayjs";
import { addRailCalendar } from "../../../../../api/apiCall";
import { useAuth } from "../../../../../auth/auth";
import { format } from "date-fns";
import { toast } from "react-toastify";

const AddNewCalendar = ({getCalendars, setOpen}: any) => {
    const {state} = useAuth();
    const [date, setDate] = useState<any>(dayjs());
    const [weeks, setWeeks] = useState(52);

    const addCalendar = async () => {
        const response: any = await addRailCalendar(state.user?.token, format(date.$d, 'yyyy-MM-dd'), weeks);
        if(response.status === 200) {
            getCalendars();
            setOpen(false);
            toast.success('Rail Calendar added successfully!')
        } else {
            toast.error('Something went wrong!')
        }
    }

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr" },
                gap: 3
            }}>
            <Typography sx={{ fontWeight: "600" }}>Add New Year Calendar</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                    <DatePicker
                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                        label="Date"
                        value={date}
                        format="DD/MM/YYYY"
                        onChange={(value) => setDate(value)} />
                </DemoContainer>
            </LocalizationProvider>
            <TextField
                label="Weeks"
                size="small"
                type="number"
                value={weeks}
                onChange={(e) => setWeeks(Number(e.target.value))}
                slotProps={{
                    htmlInput: { min: 52, max: 53 }
                }}
            />
            <div className="center-button-div">
                <Button variant="contained" onClick={addCalendar} sx={{ boxShadow: 'none', width: 150 }}>
                    Save
                </Button>
            </div>
        </Box>
    );
}

export default AddNewCalendar;
